import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailActionUnread = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "email-action-unread" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 1.5,
			y: 4.75,
			width: 21,
			height: 15,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.161,5.3l-8.144,6.264a3.308,3.308,0,0,1-4.034,0L1.839,5.3"
		})
	]
});
export default SvgEmailActionUnread;
